import type { TFunction } from 'i18next';
import mapFacets from '../../_json/mapFacets';
import type { Facets, Filter, ViewOptions } from '../../_types/Car';
import { arrAus } from '../../modules/fahrzeugsuche/filter/maps/arrAus';
import stringToSlug from '../string-to-slug';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';
import checkUndefinedOrNull from '../tools/checkUndefinedOrNull';

export default function getSearchFromString(
    searchString: string,
    facets: Facets,
    translate: TFunction
): {
    filter: Filter;
    viewOptions: ViewOptions;
} {
    const carListFilter: Filter = {};
    const carListViewOptions: ViewOptions = {};
    const workSearchString: string = decodeURIComponent(searchString).replace(/^\?/g, '');
    const mappedFacets = mapFacets(translate);
    const sAttrTranslate = arrAus(translate);

    if (!checkUndefinedOrNull(workSearchString)) {
        const checkEinzelansicht = workSearchString.match(/.*_carId[0-9]+/g);
        if (!checkUndefinedNullOrEmpty(checkEinzelansicht)) {
            const searchSplit = checkEinzelansicht[0].split('_carId');
            carListViewOptions.car = [searchSplit[0], parseFloat(searchSplit[1])];
        } else {
            carListViewOptions.car = undefined;
            const arrSplit = workSearchString?.split('&');
            for (let i = 0; i < arrSplit.length; i++) {
                const splitter = arrSplit[i];
                if (!checkUndefinedNullOrEmpty(splitter)) {
                    const split = splitter?.split('=');
                    const filterKey = split?.[0] as keyof Filter | 'fiz';
                    const searchedFacet = mappedFacets?.[filterKey];
                    const searchedValue = !checkUndefinedNullOrEmpty(split?.[1]) ? split?.[1] : undefined;

                    if (!checkUndefinedNullOrEmpty(searchedValue)) {
                        if (filterKey === 'ia') {
                            const arr = [];
                            searchedValue.split(',').map(function (item) {
                                const value = sAttrTranslate?.find((a) => a?.tSlug === stringToSlug(item))?.i;
                                if (!checkUndefinedNullOrEmpty(value)) {
                                    arr.push(value);
                                }
                            });
                            carListFilter[filterKey] = arr;
                        } else if (
                            filterKey === 'motoren' ||
                            filterKey === 'akttypList' ||
                            filterKey === 'aufbauten' ||
                            filterKey === 'Farben' ||
                            filterKey === 'Standort' ||
                            filterKey === 'Ort' ||
                            filterKey === 'idFirma' ||
                            filterKey === 'fd'
                        ) {
                            const arr = [];
                            searchedValue.split(',').map(function (item) {
                                const value = !checkUndefinedNullOrEmpty(searchedFacet?.facetName) ? facets?.[searchedFacet?.facetName]?.find((f) => f?.tSlug === stringToSlug(item))?.i : undefined;
                                if (!checkUndefinedNullOrEmpty(value)) {
                                    arr.push(value);
                                }
                            });
                            carListFilter[filterKey] = arr;
                        } else if (
                            filterKey === 'RateVon' ||
                            filterKey === 'RateBis' ||
                            filterKey === 'EZVon' ||
                            filterKey === 'EZBis' ||
                            filterKey === 'KMVon' ||
                            filterKey === 'KMBis' ||
                            filterKey === 'LeistungVon' ||
                            filterKey === 'LeistungBis' ||
                            filterKey === 'PreisVon' ||
                            filterKey === 'PreisBis'
                        ) {
                            if (checkUndefinedNullOrEmpty(carListFilter[filterKey?.replace('Von', '')?.replace('Bis', '')])) {
                                const data = [
                                    ...(facets?.[searchedFacet?.facetName]?.map((e) => e?.i) || []).map(function (e) {
                                        return { i: parseInt(e.toString()) };
                                    }),
                                ];
                                const von = Math.min(...(data?.map((e) => e?.i) || []));
                                const bis = Math.max(...(data?.map((e) => e?.i) || []));
                                carListFilter[filterKey?.replace('Von', '')?.replace('Bis', '')] = [von, bis];
                            }
                            carListFilter[filterKey?.replace('Von', '')?.replace('Bis', '')][filterKey?.endsWith('Bis') ? 1 : 0] = parseFloat(searchedValue);
                        } else if (filterKey === 'sofort' || filterKey === 'aktion') {
                            carListFilter[filterKey] = searchedValue === 'Ja';
                        } else if (filterKey === 'freier_text') {
                            carListFilter[filterKey] = searchedValue;
                        } else if (filterKey === 'moreCars' || filterKey === 'pageSize') {
                            carListFilter[filterKey] = parseInt(searchedValue);
                        } else {
                            const value = !checkUndefinedNullOrEmpty(searchedFacet?.facetName)
                                ? facets?.[searchedFacet?.facetName]?.find((f) => f?.tSlug === stringToSlug(searchedValue))?.i
                                : undefined;
                            const valueIsNumber = new RegExp(/^\d+$/).test(value);
                            carListFilter[filterKey] = valueIsNumber ? parseInt(value) : value;
                        }
                    }
                }
            }
        }
    }

    return {
        filter: carListFilter,
        viewOptions: carListViewOptions,
    };
}
